"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/ActionTypes"));

var initialState = {};

var PublicFeatureFlags = function PublicFeatureFlags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.default.PUBLIC_FEATURE_FLAGS_RECEIVED:
      return payload.featureFlags;

    default:
      return state;
  }
};

var _default = PublicFeatureFlags;
exports.default = _default;
module.exports = exports.default;